module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Thin-Alphabetic.9b260223.woff2";